module.exports = __webpack_public_path__ + "static/media/caret_down.ef120064.svg";